import React from "react";
import t from "../../../helpers/t";
import Biscuit from "../../../../utils/Biscuit";

const Notification = (props) => {
  return (
    <>
      <div className="off-canvas-form-overlay"></div>
      <div className="inb-message-box">
        <p>{props.message}</p>
        <div className="button-container">
          <button
            className={
              "button medium beautify beautify-" + Biscuit.get("user.client_id") + " round"
            }
            onClick={props.close}
          >
            <span>{t("ok")}</span>
          </button>
        </div>
      </div>
    </>
  );
};
export default Notification;
